import { createClient } from '@supabase/supabase-js'

// Use the correct project URL and anon key
const SUPABASE_URL = 'https://yhuxjecvzujpjwnpkuel.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlodXhqZWN2enVqcGp3bnBrdWVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5MjgwNzYsImV4cCI6MjA2NzUwNDA3Nn0.WImzmrUE6IMm4ffu1bLvcMktVINHLDHo_tS6mBUidHI'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Missing Supabase environment variables')
}

// Create a single instance of the Supabase client
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  },
  realtime: {
    timeout: 30000 // Increase timeout for better reliability
  },
  global: {
    headers: { 'x-application-name': 'moco-png-attendance' }
  }
})

// Test the connection and log the result
supabase.from('members_moco_png').select('count(*)', { count: 'exact', head: true })
  .then(({ error }) => {
    if (error) {
      console.error('Supabase connection test failed:', error)
    } else {
      console.log('Supabase connection successful')
    }
  })
  .catch(err => {
    console.error('Supabase connection test error:', err)
  })

export default supabase